import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-admin-zone__panel border border-yellow-300 rounded overflow-hidden bg-white min-w-0 w-full"
}
const _hoisted_2 = { class: "w-full text-sm" }
const _hoisted_3 = { class: "border-b border-gray-200" }
const _hoisted_4 = { class: "px-3 py-2 font-medium w-2/5 align-top" }
const _hoisted_5 = { class: "px-3 py-2" }
const _hoisted_6 = {
  key: 0,
  class: "border-b border-gray-200"
}
const _hoisted_7 = { class: "px-3 py-2" }
const _hoisted_8 = { class: "border-b border-gray-200" }
const _hoisted_9 = { class: "px-3 py-2" }
const _hoisted_10 = { class: "border-b border-gray-200" }
const _hoisted_11 = { class: "px-3 py-2" }
const _hoisted_12 = { class: "border-b border-gray-200" }
const _hoisted_13 = { class: "px-3 py-2" }
const _hoisted_14 = { class: "border-b border-gray-200" }
const _hoisted_15 = { class: "px-3 py-2" }
const _hoisted_16 = { class: "px-3 py-2" }
const _hoisted_17 = {
  colspan: "2",
  class: "px-3 py-3"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "order-admin-zone__panel border border-yellow-300 rounded overflow-hidden bg-white min-w-0 w-full"
}
const _hoisted_20 = { class: "w-full text-sm" }
const _hoisted_21 = { class: "border-b border-gray-200" }
const _hoisted_22 = { class: "px-3 py-2" }
const _hoisted_23 = { class: "border-b border-gray-200" }
const _hoisted_24 = { class: "px-3 py-2" }
const _hoisted_25 = { class: "border-b border-gray-200" }
const _hoisted_26 = { class: "px-3 py-2" }
const _hoisted_27 = { class: "border-b border-gray-200" }
const _hoisted_28 = { class: "px-3 py-2" }
const _hoisted_29 = { class: "border-b border-gray-200" }
const _hoisted_30 = { class: "px-3 py-2" }
const _hoisted_31 = { class: "px-3 py-2" }
const _hoisted_32 = {
  colspan: "2",
  class: "px-3 py-3"
}
const _hoisted_33 = ["disabled"]

import { computed, reactive, ref, watch } from "vue";
import { getApiBaseUrl } from "@/config/api";
import { useNotification } from "@/composables/useNotification";
import { getDomTomNameFromPostalCode } from "@/utils/domTom";
import type { OrderDetailResponse } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderAdminAddresses',
  props: {
    orderDetail: {},
    panel: {}
  },
  setup(__props: any) {

const props = __props;

const { error: notifyError, success: notifySuccess } = useNotification();

const savingLivraison = ref(false);
const savingFacturation = ref(false);

const form = reactive({
  liv: {
    societe: "",
    contact: "",
    adresse: "",
    codePostal: "",
    ville: "",
    telephone: "",
  },
  fac: {
    societe: "",
    adresse: "",
    codePostal: "",
    ville: "",
    telephone: "",
  },
});

const livraison = computed(() => props.orderDetail?.adresseLivraison ?? null);
const facturation = computed(
  () => props.orderDetail?.adresseFacturation ?? null,
);
const acheteur = computed(() => props.orderDetail?.acheteur ?? null);

/** IDs BDD sur la commande (fiables même si l'adresse affichée vient du checkout). */
const livraisonIdAdresse = computed(
  () =>
    props.orderDetail?.id_adresse_livraison ??
    livraison.value?.id_adresse ??
    null,
);

const facturationIdAdresse = computed(
  () =>
    props.orderDetail?.id_adresse_facturation ??
    facturation.value?.id_adresse ??
    null,
);

const hasLivraisonSociete = computed(() =>
  Boolean(livraison.value?.Societe?.trim()),
);

const livraisonEnseigneLabel = computed(() =>
  hasLivraisonSociete.value ? "Nom de l'enseigne" : "Nom de la société",
);

const showLivraisonContact = computed(() =>
  Boolean(livraison.value?.NomContact?.trim()),
);

function formatCountry(
  country: { id_pays: number; texte_fr: string } | null | undefined,
  postalCode: string,
): string {
  const countryName = country?.texte_fr?.trim() ?? "";
  const normalizedCountry = countryName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  const isFranceDomTom =
    country?.id_pays === 42 ||
    /france\s+dom[\s/-]*tom/.test(normalizedCountry);

  if (!isFranceDomTom) return countryName;

  const territory = getDomTomNameFromPostalCode(postalCode);

  return territory ? `${countryName} (${territory})` : countryName;
}

const livraisonPays = computed(() =>
  formatCountry(livraison.value?.pays, form.liv.codePostal),
);
const facturationPays = computed(() =>
  formatCountry(facturation.value?.pays, form.fac.codePostal),
);

function syncFormFromOrder() {
  const d = props.orderDetail;
  if (!d) return;

  form.liv.societe =
    livraison.value?.Societe?.trim() || acheteur.value?.nomSociete || "";
  form.liv.contact = livraison.value?.NomContact?.trim() || "";
  form.liv.adresse = livraison.value?.adresse ?? "";
  form.liv.codePostal = livraison.value?.codePostal ?? "";
  form.liv.ville = livraison.value?.ville ?? "";
  form.liv.telephone =
    livraison.value?.telephone || livraison.value?.mobile || "";

  form.fac.societe =
    facturation.value?.Societe?.trim() || acheteur.value?.nomSociete || "";
  form.fac.adresse = facturation.value?.adresse ?? "";
  form.fac.codePostal = facturation.value?.codePostal ?? "";
  form.fac.ville = facturation.value?.ville ?? "";
  form.fac.telephone =
    facturation.value?.telephone || facturation.value?.mobile || "";
}

watch(() => props.orderDetail, syncFormFromOrder, {
  immediate: true,
  deep: true,
});

async function saveAdresse(
  name: string,
  value: string,
  idAdresse: number | null,
): Promise<boolean> {
  if (!idAdresse) {
    notifyError("Adresse introuvable — enregistrement impossible");
    return false;
  }
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/admin-efp/groupages/save-adresse`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idAdresse, name, value }),
      },
    );
    if (!response.ok) {
      notifyError("Erreur lors de l'enregistrement de l'adresse");
      return false;
    }
    return true;
  } catch {
    notifyError("Erreur lors de l'enregistrement de l'adresse");
    return false;
  }
}

async function saveLivraison() {
  if (!livraisonIdAdresse.value || savingLivraison.value) return;

  savingLivraison.value = true;
  const id = livraisonIdAdresse.value;
  const fields: [string, string][] = [
    ["nomSociete_liv", form.liv.societe],
    ["adresse_liv", form.liv.adresse],
    ["codePostal_liv", form.liv.codePostal],
    ["ville_liv", form.liv.ville],
    ["telephone_liv", form.liv.telephone],
  ];
  if (showLivraisonContact.value) {
    fields.splice(1, 0, ["nomContact_liv", form.liv.contact]);
  }

  try {
    const results = await Promise.all(
      fields.map(([name, value]) => saveAdresse(name, value, id)),
    );
    if (results.every(Boolean)) {
      notifySuccess("Adresse de livraison enregistrée");
    }
  } finally {
    savingLivraison.value = false;
  }
}

async function saveFacturation() {
  if (!facturationIdAdresse.value || savingFacturation.value) return;

  savingFacturation.value = true;
  const id = facturationIdAdresse.value;
  const fields: [string, string][] = [
    ["nomSociete_fac", form.fac.societe],
    ["adresse_fac", form.fac.adresse],
    ["codePostal_fac", form.fac.codePostal],
    ["ville_fac", form.fac.ville],
    ["telephone_fac", form.fac.telephone],
  ];

  try {
    const results = await Promise.all(
      fields.map(([name, value]) => saveAdresse(name, value, id)),
    );
    if (results.every(Boolean)) {
      notifySuccess("Adresse de facturation enregistrée");
    }
  } finally {
    savingFacturation.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.panel === 'livraison')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "order-admin-zone__heading flex items-center gap-2 px-3 py-2 bg-[#fcf8e3] border-b border-yellow-300" }, [
          _createElementVNode("span", { class: "font-semibold text-[#8a6d3b]" }, "Admin"),
          _createElementVNode("span", { class: "text-sm font-medium text-[#8a6d3b]" }, "Adresse de livraison")
        ], -1)),
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_3, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(livraisonEnseigneLabel.value), 1),
              _createElementVNode("td", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.liv.societe) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.liv.societe]
                ])
              ])
            ]),
            (showLivraisonContact.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _cache[11] || (_cache[11] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Nom du contact", -1)),
                  _createElementVNode("td", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.liv.contact) = $event)),
                      type: "text",
                      class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                    }, null, 512), [
                      [_vModelText, form.liv.contact]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", _hoisted_8, [
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Adresse", -1)),
              _createElementVNode("td", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.liv.adresse) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.liv.adresse]
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_10, [
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Code postal", -1)),
              _createElementVNode("td", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.liv.codePostal) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.liv.codePostal]
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_12, [
              _cache[14] || (_cache[14] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Ville", -1)),
              _createElementVNode("td", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.liv.ville) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.liv.ville]
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_14, [
              _cache[15] || (_cache[15] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Pays", -1)),
              _createElementVNode("td", _hoisted_15, _toDisplayString(livraisonPays.value), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[16] || (_cache[16] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Téléphone", -1)),
              _createElementVNode("td", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.liv.telephone) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.liv.telephone]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50",
                  disabled: savingLivraison.value || !livraisonIdAdresse.value,
                  onClick: saveLivraison
                }, _toDisplayString(savingLivraison.value ? "Enregistrement…" : "Enregistrer"), 9, _hoisted_18)
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "order-admin-zone__heading flex items-center gap-2 px-3 py-2 bg-[#fcf8e3] border-b border-yellow-300" }, [
          _createElementVNode("span", { class: "font-semibold text-[#8a6d3b]" }, "Admin"),
          _createElementVNode("span", { class: "text-sm font-medium text-[#8a6d3b]" }, "Adresse de facturation")
        ], -1)),
        _createElementVNode("table", _hoisted_20, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_21, [
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "px-3 py-2 font-medium w-2/5 align-top" }, " Nom de la société ", -1)),
              _createElementVNode("td", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.fac.societe) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.fac.societe]
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_23, [
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Adresse", -1)),
              _createElementVNode("td", _hoisted_24, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.fac.adresse) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.fac.adresse]
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_25, [
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Code postal", -1)),
              _createElementVNode("td", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.fac.codePostal) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.fac.codePostal]
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_27, [
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Ville", -1)),
              _createElementVNode("td", _hoisted_28, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.fac.ville) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.fac.ville]
                ])
              ])
            ]),
            _createElementVNode("tr", _hoisted_29, [
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Pays", -1)),
              _createElementVNode("td", _hoisted_30, _toDisplayString(facturationPays.value), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[23] || (_cache[23] = _createElementVNode("td", { class: "px-3 py-2 font-medium align-top" }, "Téléphone", -1)),
              _createElementVNode("td", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.fac.telephone) = $event)),
                  type: "text",
                  class: "w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
                }, null, 512), [
                  [_vModelText, form.fac.telephone]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_32, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50",
                  disabled: savingFacturation.value || !facturationIdAdresse.value,
                  onClick: saveFacturation
                }, _toDisplayString(savingFacturation.value ? "Enregistrement…" : "Enregistrer"), 9, _hoisted_33)
              ])
            ])
          ])
        ])
      ]))
}
}

})